import { TranslationKeys } from '../types';
import { en } from './en/index';

const enTranslations: TranslationKeys = en;

export default enTranslations;
